/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from 'react';
import {Form} from 'informed';

import {DialogTitle} from '@material-ui/core';
import InviteForm from './form.invite';

function InviteProfessionalForm({saving, onSubmit, onCancel, isOwner}) {
  return (
    <>
      <DialogTitle>Invite Professional</DialogTitle>
      <Form
        render={({...props}) => <InviteForm onCancel={onCancel} saving={saving} isOwner={isOwner} relationshipExamples="Speech Therapist, Physio" {...props} />}
        initialValues={{permissions: 'admin'}}
        onSubmit={values => onSubmit({...values, type: 'professional'})}
      />
    </>
  );
}

export default InviteProfessionalForm;
